export default __webpack_public_path__ + "static/media/softcom.0604d61e.png";